// Archivo generado automáticamente por scripts/generate-version.cjs
// No editar a mano.
export { BUILD_VERSION as APP_VERSION } from '../build-info';
